import React from "react";

import StyledFormInput from "components/FormInput/FormInput";

import usePaymentPurposeKeyDown from "./usePaymentPurposeKeyDown";

const PaymentPurposeField: React.FC = () => {
  const handleKeyDown = usePaymentPurposeKeyDown();

  return (
    <StyledFormInput
      title="Призначення платежу"
      name="paymentPurpose"
      multiline
      rows={4}
      fullWidth
      slotProps={{
        input: {
          inputProps: {
            maxLength: 140,
            onKeyDown: handleKeyDown,
          },
        },
      }}
    />
  );
};

export default PaymentPurposeField;
